import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import Logo from '../../Logo';
import styles from '../Navigation.css';


const NavigationBarLeftContainer = ({
  companyName,
  isMobile,
  isTablet,
  setIsSiderOpen,
}) => {
  if (isMobile || isTablet) {
    return (
      <React.Fragment>
        <div className={styles.navbarLeftButtonContainer}>
          <button
            className={cx(styles.menuButton, styles.showOnMobile)}
            aria-label="Open Main Menu"
            onClick={() => setIsSiderOpen(true)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
        <div className={styles.navbarLeftLogoContainer}>
          <Logo className={styles.logo} />
        </div>
      </React.Fragment>
    );
  }

  return (
    <Link
      to={'/'}
      className={styles.srOnly}
      aria-label={companyName ? `${companyName} logo, homepage` : 'Homepage'}
    >
      <Logo className={styles.logo} />
    </Link>
  );
};

NavigationBarLeftContainer.propTypes = {
  companyName: PropTypes.string,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  setIsSiderOpen: PropTypes.func,
};

export default NavigationBarLeftContainer;



// WEBPACK FOOTER //
// ./src/client/Components/Navigation/components/NavigationBarLeftContainer.js